import { render, staticRenderFns } from "./VersionPatchTask.vue?vue&type=template&id=4d0ab11c&"
import script from "./VersionPatchTask.vue?vue&type=script&lang=js&"
export * from "./VersionPatchTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports